module.exports = __webpack_public_path__ + "static/img/19.25ea05c7.png";